export default "__VITE_ASSET__Cg5_Yn_e__"